import { DarkMode } from "@chakra-ui/react";
import React from "react";
import { useCurrentBreakpoint } from "../../../hooks/useCurrentBreakpoint";
import { useCurrentAccountStore } from "../../../store/currentAccountStore";
import { DesktopNavbar } from "./DesktopNavbar";
import { MobileNavbar } from "./MobileNavbar";

// zindex of main navigation elements, sits over most elements except modals
// which have z-index of 10.
export const TOP_NAV_ZINDEX = 9;

export function Navbar() {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  const isMobile = useCurrentBreakpoint().isAtMost("sm");

  return (
    <DarkMode>
      {isMobile ?
        <MobileNavbar accountId={accountId} />
      : <DesktopNavbar accountId={accountId} />}
    </DarkMode>
  );
}
